<template>
<article class="message">
  <!-- <div class="message-header">
    Context Item
    <slot></slot>
  </div> -->
  <div class="message-body">
    <slot></slot>
    <div class="field top-group">
      <div class="field-body">
        <form-field icon="circle" title="Type" classes="is-narrow">
          <multiselect
            v-model="internalContextItem.type"
            :options="contextTypeOptions"
            :searchable="false"
            :close-on-select="true"
            :show-labels="false"
            placeholder="Pick a Type">
          </multiselect>
        </form-field>
        <form-field icon="name" title="Name">
          <input v-model="internalContextItem.name"
            class="input"
            type="text"
            placeholder="Name">
        </form-field>
      </div>
    </div>

    <div class="field has-addons">
      <a v-on:click="addExpression('')" class="button add">
        <i class="fas fa-plus"></i>
        Add Expression
      </a>
    </div>

    <div
      v-for="(expr,index) in internalContextItem.exprs"
      :key="'expr'+index"
      class="field is-horizontal">
      <a v-on:click="removeExpression(index)" class="button button-inverse full-height">
        <i class="fas fa-times"></i>
      </a>
      <input v-model="internalContextItem.exprs[index]"
        class="input"
        type="text"
        placeholder="Expression">
    </div>
  </div>
</article>
</template>

<script>
import contextDefinitions from '@/defs/context.json';
import Multiselect from 'vue-multiselect';
import FormField from '@/components/forms/FormField.vue';


export default {
  name: 'AnalyticContextItem',
  components: {
    Multiselect,
    FormField,
  },
  props: {
    contextItem: {
      type: Object,
      required: true,
    },
    eventDef: {
      type: Object,
      required: true,
    },
    deleteMethod: {
      type: Function,
      required: true,
    },
    index: {
      type: Number,
      required: true,
    },
  },
  watch: {
    internalContextItem: {
      deep: true,
      handler() {
        this.$emit('update:contextItem', this.computedItem);
      },
    },
  },
  methods: {
    removeExpression(index) {
      // Remove an expression if there is more than one
      if (this.internalContextItem.exprs.length > 1) {
        this.internalContextItem.exprs.splice(index, 1);
      }
    },
    addExpression(value) {
      this.internalContextItem.exprs.push(value);
    },
  },
  data() {
    return {
      contextTypeOptions: contextDefinitions.types,
      internalContextItem: this.contextItem,
    };
  },
};
</script>

<style lang="scss" scoped>

.field {
  span {
    line-height: 2.3rem;
    margin-left: 1rem;
  }
}

.control {
  a {
    background: $border-color;
    color: $font-color;
  }
}

.remove {
  margin-top: 2.5em;
}

.top-group {
  margin-bottom: 1.5em;
}

.expr {
  svg {
    width: .875em;
  }
}

article {
  background-color: $form-subitem;
}

.message-body {
  padding: .5rem;
  position: relative;
}

.analytic-context-item, .analytic-context-exprs {
  padding: .75rem;
  border: 2px solid $border-color;
  background-color: $form-subitem;
  margin-bottom: $form-padding;

  a.add {
    margin-top: 1.25rem;
    margin-bottom: .25rem;
  }

  a.button {
    border: 0px;
  }

  div.expr {
    // border: 1px solid $border-color;
    margin: 10px 0;
    // padding: 10px;
  }
}

</style>
